import { render, staticRenderFns } from "./Joacv.vue?vue&type=template&id=6eacaada&scoped=true&"
import script from "./Joacv.vue?vue&type=script&lang=js&"
export * from "./Joacv.vue?vue&type=script&lang=js&"
import style0 from "./Joacv.vue?vue&type=style&index=0&id=6eacaada&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eacaada",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
